export default {
  meta: {
    label: 'Danish'
  },
  data: {
    'da-DK': {
      97:  [['🚑','ambulance'], ['👽','alien'], ['⚓','anker`']],
      98:  [['👶','baby'], ['🍌','banan'], ['🧒','barn'], ['🐙','blæksprutte'], ['🐝','bi'], ['🥓','bacon'], ['🥯','bagel'], ['🍞','brød'], ['🎈','ballon'], ['🛁','badekar'], ['🐻','bære'], ['🌊','bølge']],
      99:  [['🚲', 'cykel'], ['🍫','chokolade'], ['🍄','champignon']],
      100: [['💃','danser'],['👸🏻','dronning'], ['🦕','dinosaurus']],
      101: [['🐘', 'elefant'], ['🦄','enhjørning']],
      102: [['🦎','firben'], ['🦇','flagermus'], ['✈','flyvemaskine'], ['🐸','frø']],
      103: [['🎁', 'gave'], ['🦡','grævling'], ['🦍','gorilla']],
      104: [['🎩', 'hat'], ['🐶','hund'], ['🦌','hjort'], ['🏠', 'hus'], ['🚁','helikopter']],
      105: [['🍦','is']],
      106: [['🌍', 'jorden'], ['🤹🏼‍','jonglør']],
      107: [['🦃','kalkun'], ['🐄','ko'], ['🐱','kat'], ['🐈','kat'], ['🛶','kano'], ['🔪','kniv'], ['🐇','kanin'], ['🐊','krokodille'], ['🦀','krabbe']],
      108: [['🦁','løve'], ['🐆','leopard']],
      109: [['🐜','myre'], ['🌙','måne'], ['🍈','melon'], ['👄','mund'], ['🐁','mus']],
      110: [['👃','næse'], ['🔑','nøgle']],
      111: [['🧀','ost']],
      112: [['🥞','pandekager'], ['☂️','paraply'], ['📫','postkasse'], ['🦜','papegøje']],
      114: [['🤖','robot'], ['🚀','raket'], ['🦊','ræv']],
      115: [['🥗','salat'], ['🐍','slange'], ['⭐️','stjerne'], ['👻','spøgelse'], ['🐌','snegl']],
      116: [['🐯','tiger'], ['🌲','træ'], ['🐅','tiger'], ['🍅','tomat']],
      117: [['🦉','ugle']],
      118: [['🍇','vindruer'], ['🎻','violin'], ['🍉','vandmelon'], ['🌋','vulkan']],
      122: [['🦓','zebra']],
      230: [['🍎','æble'], ['🥚','æg']],
      248: [['👁️','øje'], ['🦅','ørn']],
    }
  }
};
